<template>
    <!-- <transition name="fade"> -->
        <div v-if="isOnRoute">
            <slot />
        </div>
    <!-- </transition> -->
</template>


<script>
import framework from '../../framework';

/**
 *  The x-route component.
 *  @module components/x-route
 */


/**
 * The x-route component
 */
export default {
    name: 'x-route',
    mixins: [
        framework.mixins.abstractElement,
    ],
    props: {
        dataRoute: String,
        dataComponentName: String,
    },


    mounted() {
        this.createRoute();

        if (this.$route.params.redirectTo) {
            this.$router.push(this.$route.params.redirectTo);
        }
    },
    methods: {
        /**
         * Get the route array.
         * @returns {Array} the array.
         */
        getRouteArray() {
            // If already in the store, return that.
            let routeArray = this.$store.getters.getRouteArray;
            if (routeArray) {
                return routeArray;
            }

            // If not, get it from the custom interactions
            // this function should be in the app's custom interactions
            let func = this.convertInteractionFunction('getRouteArray');
            if (func) {
                routeArray = func();
            } else {
                routeArray = [];
            }

            this.$store.commit(
                framework.storeConstants.MutationTypes.SetRouteArray,
                {
                    routeArray,
                }
            );

            return routeArray;
        },

        /**
         * Get the route combinations that need to be stopped and returned to start of app.
         * @returns {Array} the pair.
         */
        getBackButtonGuardPairs() {
            // this function can should be on in the app's custom interactions
            let func = this.convertInteractionFunction('getBackButtonGuardPairs');
            if (func) {
                return func();
            }

            return [];
        },

        /**
         * Get the route combinations that need to provide alert before allowing .
         * @returns {Array} array of pair and message.
         */
        getBackButtonAlertPairs() {
            // this function can should be on in the app's custom interactions
            let func = this.convertInteractionFunction('getBackButtonAlertPairs');
            if (func) {
                return func();
            }

            return [];
        },

        /**
         * Whether this is a back nav action
         * always allow back navigation within a manifest even if there are
         * validation errors
         * @param {string} fromPath the path they are coming from.
         * @param {string} toPath the path they are going to.
         * @returns {Boolean} Whether it is a back nav.
         */
        isBackNavigation(fromPath, toPath) {
            let routes = this.getRouteArray();

            let from = routes.find((r) => r.path === fromPath);
            let to = routes.find((r) => r.path === toPath);

            // This means one of the paths isn't in the registered list, allow?
            if (from === undefined || to === undefined) {
                return true;
            }

            // This means they have jumped to the next or previous manifest
            if (from.manifest !== to.manifest) {
                return true;
            }

            return from.order > to.order;
        },

        /**
         * Adds the route to the route table if it hasn't already been added.
         * @returns {void}
         */
        createRoute() {
            // only add the route if it hasn't already been added
            let matched = this.$router.getMatchedComponents(this.route);
            if (matched.length > 0) {
                return;
            }
            this.$router.addRoutes([
                {
                    path: this.route,
                    component: this.applicationInstance.vueInstance.$options
                        .components[this.componentName],
                    beforeEnter: (to, from, next) => {
                        // this only occurs when clicking the browser back button from a route
                        // on one manifest to a route on another manifest
                        // It will error out, so go to the first page.
                        let backButtonGuardPairs = this.getBackButtonGuardPairs();
                        for (let i = 0; i < backButtonGuardPairs.length; i++) {
                            if (from.path === backButtonGuardPairs[i].from
                                && to.path === backButtonGuardPairs[i].to) {
                                next('/');
                                window.scrollTo(0, 0);
                                return;
                            }
                        }

                        // this only occurs when clicking the browser
                        // or regular back button from a route
                        // on one manifest(specifically wpa_form) to a
                        //  route on another manifest(wpa_filter)
                        // All entered data from wpa_form will be lost, so allow confirmation.
                        let backButtonAlertPairs = this.getBackButtonAlertPairs();
                        for (let i = 0; i < backButtonAlertPairs.length; i++) {
                            if (from.path === backButtonAlertPairs[i].from
                                && to.path === backButtonAlertPairs[i].to) {
                                let dialogConfirm = this.convertInteractionFunction('confirm');
                                dialogConfirm('backConfirmationDialog')
                                    .then((dialogResult) => {
                                        if (dialogResult === 'CANCEL') {
                                            window.scrollTo(0, 0);
                                            return;
                                        }

                                        // TODO: Specific to WageComplaint
                                        this.$router.push({
                                            name: 'StartForm',
                                            params: {
                                                redirectTo: '/filter',
                                            },
                                        });
                                    });
                                return;
                            }
                        }

                        if (this.isBackNavigation(from.path, to.path)) {
                            next();
                            return;
                        }

                        this.$store.dispatch(
                            framework.storeConstants.ActionTypes.NavigateWithValidation,
                            {
                                toRoute: to.path,
                                fromRoute: from.path,
                            }
                        ).then((response) => {
                            if (response.authorized) {
                                window.scrollTo(0, 0);
                                next();
                            } else {
                                // scroll to top of document if there are still validation erros
                                // this will place user where they can see the error list
                                window.scrollTo(0, 0);
                            }
                        });
                    },
                },
            ]);
        },
    },
    computed: {
        isOnRoute() {
            return this.route === this.$route.path;
        },
        route() {
            return this.getAttribute('route', null,
                new framework.errors.MissingComponentAttributeError('x-route', 'route'));
        },
        componentName() {
            return this.getAttribute('componentName', null,
                new framework.errors.MissingComponentAttributeError('x-route', 'componentName'));
        },
        onRouteEnterFunction() {
            if (this.dataOnRouteEnterFunction) {
                return this.dataOnRouteEnterFunction;
            }

            if (this.nodeManifest && this.nodeManifest.attributes.onRouteEnterFunction) {
                let func = this.convertInteractionFunction(
                    this.nodeManifest.attributes.onRouteEnterFunction);
                if (func) {
                    return func;
                }
            }

            return null;
        },
    },
};

</script>

<style lang="scss">
    @import
        "../../styles/settings",
        "route";
</style>





// WEBPACK FOOTER //
// source/components/x-route/x-route.vue